export default {
  importPlansFor: 'Importar planos para o modelo:',
  import: 'Importar',
  json: 'JSON',
  createdPlans: 'Planos criados:',
  errors: 'Erros:',
  invalidJson: 'JSON inválido',
  noPlansToImport: 'Não há planos disponíveis para importar',
  missingPlanName: 'Nome do plano ausente',
  channelMismatch: 'Seus canais de mídia não correspondem exatamente ao modelo. Faltando no plano: {missing}. Não estão no modelo: {extra}. Nada foi importado.',
  touchpointMismatch: 'Referencia mídias que não existem no modelo: {items}. Nada foi importado.'
}
